/* eslint no-invalid-this: "off" */

const EMAIL_REGEX = /^(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){255,})(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){65,}@)(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22))(?:\.(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22)))*@(?:(?:(?!.*[^.]{64,})(?:(?:(?:xn--)?[a-z0-9]+(?:-+[a-z0-9]+)*\.){1,126})+(?:(?:[a-z][a-z0-9]*)|(?:(?:xn--)[a-z0-9]+))(?:-+[a-z0-9]+)*)|(?:\[(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){7})|(?:(?!(?:.*[a-f0-9][:\]]){7,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?)))|(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){5}:)|(?:(?!(?:.*[a-f0-9]:){5,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3}:)?)))?(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))(?:\.(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))){3}))]))$/i;
const CHECKABLE_DOMAINS = {
  gmail: 6,
  hotmail: 4,
  live: 4,
  msn: 4,
  yahoo: 4,
  ymail: 4
};

const optionalRequired = (propName) => {
  return function optionalRequiredValidator(value) {
    if (typeof this.target[propName] === 'undefined') return false;
    return Boolean(this.target[propName]) || Boolean(value);
  };
};

const hasUppercaseLetter = (input) => {
  return /(?=.*[A-Z])/.test(input);
};

const hasAtLeastOneNumber = (input) => {
  return /(?=.*[0-9])/.test(input);
};

const hasSpecialCharacter = (input) => {
  return /(?=.*[^a-zA-Z0-9\s])/.test(input);
};

const doesMatchEmail = (input, email) => {
  const emailUser = email.substring(0, email.indexOf('@'));
  const regex = new RegExp(`\\w*${emailUser}\\w*`, 'i');
  return regex.test(input);
}

const doesMatchString = (input, name) => {
  const caseInsensitiveInput = input.toLowerCase();
  const caseInsensitiveName = name.toLowerCase();
  return caseInsensitiveInput.includes(caseInsensitiveName);
};

const hasNoBlankSpace = (input) => {
  return !/\s/.test(input);
};

const emailLike = (email) => {
  if (email === null) {
    return true;
  }
  const e = email.trim();
  if (e.length === 0) {
    return true;
  }
  const validEmail = EMAIL_REGEX.test(e);
  if (validEmail) {
    const emailParts = email.split('@');
    if (emailParts.length === 2) {
      for (const key in CHECKABLE_DOMAINS) {
        /* istanbul ignore next */
        if (!CHECKABLE_DOMAINS.hasOwnProperty(key)) continue;
        if (emailParts[1].indexOf(key) === -1 || emailParts[0].length >= CHECKABLE_DOMAINS[key]) continue;
        return false;
      }
    }
  }

  return validEmail;
};

const phoneLike = (phone) => {
  if (phone === null) {
    return true;
  }
  phone = phone.trim();
  if (phone.length === 0) {
    return true;
  }
  const empty = new RegExp('^[\+][0-9]{1,3}$');
  if (empty.test(phone)) {
    return true;
  }
  if (phone.substring(0, 3) === '+1 ') {
    return phone.length === 17;
  }
  if (phone.substring(0, 4) === '+01 ') {
    return phone.length === 18;
  }
  phone = phone.replace(/\D/g, '');
  const regex = new RegExp('^[0-9]{7,15}$');
  return regex.test(phone);
};

export {
  optionalRequired,
  emailLike,
  phoneLike,
  hasAtLeastOneNumber,
  hasUppercaseLetter,
  hasSpecialCharacter,
  doesMatchEmail,
  doesMatchString,
  hasNoBlankSpace,
};
